import React from 'react';
import { Image, Text, View } from 'react-native';
import { img_and_onboarding_enable_kbd, img_scr_onboarding_03_a_and } from '../../../../utils/ImagesManagementUtils';
import { getRef, LocStr, xlateText } from '../../../../utils/Utils';
import HugeSquareWithTextAndBtn from '../../AuxiliaryComponent/MixComponent/HugeSquareWithTextAndBtn';
import { Onboarding_example } from '../../../../utils/DictionaryManagementUtils';
import { textPrimary_9_3 } from '../../AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================
const EnableKeyboardAndroidFP = ({
  globJSON,
  simPlatform,
  language,
  withOutTitle,
  selectKeyboard,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { announcement } = globJSON.configurations.onboarding;
  const { instructions } = globJSON.configurations.onboarding;
  const myStyles = {
    container: {
      width: 240,
    },
    imagePhoneStyle: {
      width: 180,
      height: 175,
      alignSelf: 'center',
      marginTop: withOutTitle ? 30 : 50,
    },
    FirstLinetxtStyle: {
      width: 104,
      color: '#010101',
    },
    firstLineView: {
      width: 104,
      height: 20,
      marginLeft: 67,
      marginTop: withOutTitle ? 95 : 115,
      position: 'absolute',
      justifyContent: 'center',
    },
    phoneImage: {
      width: 240,
      height: 427,
      marginTop: !withOutTitle && 20,
      position: 'absolute',
      backgroundColor: '#f0f5f9',
    },
    lblPhoneTitle: {
      width: 240,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      color: colors.primary_font_color,
      position: 'absolute',
    },
  };

  return (
    <View style={myStyles.container} ref={getRef(slideshowRefs)}>
      {!selectKeyboard ? (
        <View>
          {!withOutTitle
                    && (
                    <Text
                      style={[myStyles.lblPhoneTitle, { opacity: announcement.enable_keyboard_activation_flow ? 1.0 : 0.5 }]}
                    >
                      {LocStr(Onboarding_example, language)}
                    </Text>
                    )}
          <Image
            fadeDuration={0}
            style={myStyles.phoneImage}
            source={img_scr_onboarding_03_a_and}
          />
          <Image
            fadeDuration={0}
            style={myStyles.imagePhoneStyle}
            source={img_and_onboarding_enable_kbd}
          />
          <View style={myStyles.firstLineView}>
            <Text style={[textPrimary_9_3(globJSON, simPlatform), myStyles.FirstLinetxtStyle]}>
              {xlateText(instructions.bank_keyboard, globJSON)}
            </Text>
          </View>
          <HugeSquareWithTextAndBtn
            globJSON={globJSON}
            simPlatform={simPlatform}
            is_step_1_of_2
          />
        </View>
      ) : <View />}
    </View>

  );
};

export default EnableKeyboardAndroidFP;
